<template>
	<v-footer id="default-footer" class="landing-footer" inset>
		<v-container class="pa-8 pa-md-12">
			<v-row>
				<v-col cols="12" md="6" class="pl-md-8">
					<div class="d-flex align-center mb-3">
						<span class="brand-title-accent font-weight-black fs-h3">جت اقساط</span>
						<span class="mx-2 white--text opacity-50">•</span>
						<span class="white--text fs-h5 font-weight-medium">اولین سامانه مدیریت اقساط ابری</span>
					</div>
					<p class="white--text text--lighten-2 line-height-2 font-weight-light mb-6 text-justify">
						سامانه تحت وب جت اقساط، بستری هوشمند و چابک برای مدیریت فروش‌های اقساطی، صندوق‌های وام، کنترل چک و اسناد و یادآوری پیامکی سررسید‌ها به منظور توسعه و شفافیت کسب‌وکار شما.
					</p>

					<div class="contact-list-box mb-6">
						<div class="contact-item">
							<div class="contact-icon-wrap">
								<v-icon color="#ffb74d" small>mdi-cellphone</v-icon>
							</div>
							<div class="contact-text">
								<span class="contact-label">پشتیبانی و تماس:</span>
								<a href="tel:09361995434" class="contact-value" dir="ltr">۰۹۳۶ ۱۹۹ ۵۴۳۴</a>
							</div>
						</div>

						<div class="contact-item">
							<div class="contact-icon-wrap">
								<v-icon color="#ffb74d" small>mdi-email-outline</v-icon>
							</div>
							<div class="contact-text">
								<span class="contact-label">پست الکترونیکی:</span>
								<a href="mailto:info@jetaqsaat.ir" class="contact-value" dir="ltr">info@jetaqsaat.ir</a>
							</div>
						</div>

						<div class="contact-item">
							<div class="contact-icon-wrap">
								<v-icon color="#ffb74d" small>mdi-map-marker-outline</v-icon>
							</div>
							<div class="contact-text">
								<span class="contact-label">دفتر مرکزی:</span>
								<span class="contact-value">شیراز - حدفاصل استقلال و بزین، نسترن ۱، پلاک ۶</span>
							</div>
						</div>
					</div>

					<div class="footer-social-enamad">
						<div class="social-box">
							<span class="white--text font-weight-bold ml-2">شبکه‌های اجتماعی:</span>
							<v-btn fab x-small color="#ffffff" elevation="2" class="social-btn mx-1" href="https://wa.me/989361995434" target="_blank" aria-label="واتساپ">
								<v-icon color="#25D366" small>mdi-whatsapp</v-icon>
							</v-btn>
							<v-btn fab x-small color="#ffffff" elevation="2" class="social-btn mx-1" href="https://ble.ir/jetaqsaat" target="_blank" aria-label="بله">
								<img src="/bale_logo.png" alt="بله" style="width:16px" />
							</v-btn>
							<v-btn fab x-small color="#ffffff" elevation="2" class="social-btn mx-1" href="https://www.instagram.com/jetaqsaat?exln=MWkycHIzc3EybXN5bw==" target="_blank" aria-label="اینستاگرام">
								<v-icon color="#0088cc" small>mdi-instagram</v-icon>
							</v-btn>
						</div>

						<div class="enamad-box mt-3 mt-sm-0">
							<a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=661287&Code=QlCVJigVAF1nLPaU2UqyZ2nLPkH4K8YN" class="enamad-link">
								<img referrerpolicy="origin" src="https://trustseal.enamad.ir/logo.aspx?id=661287&Code=QlCVJigVAF1nLPaU2UqyZ2nLPkH4K8YN" alt="اینماد" code="QlCVJigVAF1nLPaU2UqyZ2nLPkH4K8YN" />
							</a>
						</div>
					</div>
				</v-col>

				<!-- Consultation Form Column -->
				<v-col cols="12" md="6" id="consultation" class="consultation-anchor-col">
					<div class="consultation-card">
						<div class="consultation-header mb-4">
							<div class="d-flex align-center">
								<div class="consultation-badge-icon ml-3">
									<v-icon color="#522ea8">mdi-headphones</v-icon>
								</div>
								<div>
									<h3 class="fs-h3 white--text font-weight-black mb-1">درخواست مشاوره رایگان</h3>
									<p class="white--text text--lighten-3 font-weight-light mb-0 fs-subtitle-1">
										شماره تماس خود را ثبت کنید؛ کارشناسان جت اقساط جهت راهنمایی و تست با شما تماس می‌گیرند.
									</p>
								</div>
							</div>
						</div>

						<v-form ref="consultantForm" lazy-validation class="consultantForm" @submit.prevent="submitConsultant">
							<v-row dense>
								<v-col cols="12">
									<v-text-field ref="consultantName" dark filled rounded v-model="consultant.name" label="نام و نام خانوادگی یا نام فروشگاه" prepend-inner-icon="mdi-account-outline" :error-messages="errorMessages" :rules="[(value) => !!value || 'نام الزامی است']" required />
								</v-col>

								<v-col cols="12">
									<v-text-field ref="consultantPhone" dark filled rounded maxlength="20" v-model="consultant.phone" label="شماره موبایل تماس" prepend-inner-icon="mdi-phone-outline" :error-messages="errorMessages" :rules="[(value) => !!value || 'شماره تماس الزامی است']" required />
								</v-col>

								<v-col cols="12">
									<v-textarea v-model="consultant.description" dark filled rounded maxlength="1000" auto-grow rows="3" label="شرح نیاز یا سوال شما (اختیاری)" prepend-inner-icon="mdi-comment-text-outline" :error-messages="errorMessages"></v-textarea>
								</v-col>

								<v-col cols="12">
									<div class="d-flex align-center captcha-row flex-wrap">
										<v-text-field label="کد امنیتی" dark style="min-width:240px" filled rounded maxLength="4" v-model="consultantCaptcha" class="flex-grow-1" prepend-inner-icon="mdi-shield-check-outline" />
										<div class="mr-3 d-flex align-center" style="direction: ltr;">
											<v-btn class="mr-1" color="white" small fab icon @click="refreshConsultantCaptcha()">
												<v-icon>mdi-refresh</v-icon>
											</v-btn>
											<CaptchaImage ref="consultantCaptcha" :codeType="['0']" style="direction: ltr;" />
										</div>
									</div>
								</v-col>

								<v-col cols="12">
									<v-btn :loading="consultantLoading" class="consultant-submit-btn" rounded large block dark type="submit">
										<v-icon left>mdi-send-outline</v-icon>
										ثبت درخواست مشاوره رایگان
									</v-btn>

									<div v-show="consultantSummery" class="pa-3 mt-3 rounded-lg text-center" :class="consultantSummeryColor">
										{{ consultantSummery }}
									</div>
								</v-col>
							</v-row>
						</v-form>
					</div>
				</v-col>
			</v-row>
		</v-container>

		<div class="footer-bottom-bar">
			<div class="text-center white--text opacity-70 fs-h6">
				کلیه حقوق مادی و معنوی این سامانه متعلق به <strong class="white--text">جت اقساط</strong> می‌باشد. کپی رایت {{ year }} ©
			</div>
		</div>
	</v-footer>
</template>

<script>
import api from '@/util/app-api'
import Links from '@/components/Links'

export default {
	name: 'DefaultFooter',

	components: { Links },

	data: () => ({
		errorMessages: '',
		consultantSummeryColor: '',
		consultant: { name: '', phone: '', description: '' },
		consultantLoading: false,
		consultantSummery: '',
		consultantCaptcha: ''
	}),

	computed: {
		year() {
			let today = new Date().toLocaleDateString('fa-IR')
			return today.substring(0, 4)
		}
	},

	methods: {
		refreshConsultantCaptcha() {
			if (this.$refs.consultantCaptcha && this.$refs.consultantCaptcha.refresh) {
				this.$refs.consultantCaptcha.refresh()
			}
		},
		submitConsultant() {
			if (this.$refs.consultantCaptcha && !this.$refs.consultantCaptcha.verify(this.consultantCaptcha)) {
				this.consultantSummery = 'کد امنیتی صحیح نمی باشد.'
				this.consultantSummeryColor = 'error'
				this.refreshConsultantCaptcha()
				return
			}
			if (!this.$refs.consultantForm.validate()) { return }

			this.consultantSummery = ''
			this.consultantLoading = true
			this.consultantSummeryColor = ''

			api.post('consultant/create', this.consultant, { authHeader: false })
				.then(() => {
					this.consultantSummery = 'درخواست شما با موفقیت ثبت شد؛ کارشناسان ما به زودی با شما تماس خواهند گرفت.'
					this.consultant = { name: '', phone: '', description: '' }
					this.consultantSummeryColor = 'success'
					this.consultantCaptcha = ''
					this.refreshConsultantCaptcha()
				})
				.catch(err => {
					this.consultantSummery = err.message || 'خطایی در ارسال رخ داد.'
					this.consultantSummeryColor = 'error'
				})
				.finally(() => {
					this.consultantLoading = false
				})
		}
	}
}
</script>

<style lang="scss">
.landing-footer {
	background: linear-gradient(145deg, #1f113a 0%, #2f175a 50%, #170b2d 100%) !important;
	border-top: 1px solid rgba(82, 46, 168, 0.4);
	position: relative;
	color: #fff;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		right: 15%;
		width: 400px;
		height: 250px;
		background: radial-gradient(circle, rgba(110, 65, 220, 0.22) 0%, transparent 70%);
		pointer-events: none;
	}

	.brand-title-accent {
		color: #ffb74d;
		font-family: "Emkan-Bold", "Yekan", sans-serif;
	}

	.contact-list-box {
		display: flex;
		flex-direction: column;
		gap: 12px;

		.contact-item {
			display: flex;
			align-items: center;

			.contact-icon-wrap {
				width: 36px;
				height: 36px;
				border-radius: 10px;
				background: rgba(255, 255, 255, 0.08);
				display: flex;
				align-items: center;
				justify-content: center;
				margin-left: 12px;
				border: 1px solid rgba(255, 255, 255, 0.1);
			}

			.contact-text {
				display: flex;
				align-items: center;
				gap: 8px;

				.contact-label {
					color: rgba(255, 255, 255, 0.65);
					font-size: 0.85rem;
				}

				.contact-value {
					color: #ffffff;
					font-weight: 600;
					font-size: 0.95rem;
					text-decoration: none;

					&:hover {
						color: #ffb74d;
					}
				}
			}
		}
	}

	.footer-social-enamad {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-top: 16px;
		border-top: 1px solid rgba(255, 255, 255, 0.1);

		.social-box {
			display: flex;
			align-items: center;

			.social-btn {
				transition: transform 0.2s ease;

				&:hover {
					transform: translateY(-2px);
				}
			}
		}

		.enamad-link {
			background: #ffffff;
			border-radius: 12px;
			padding: 4px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);

			img {
				width: 65px;
				height: 65px;
				object-fit: contain;
			}
		}
	}

	.consultation-card {
		background: rgba(255, 255, 255, 0.05);
		backdrop-filter: blur(12px);
		-webkit-backdrop-filter: blur(12px);
		border: 1px solid rgba(255, 255, 255, 0.12);
		border-radius: 24px;
		padding: 24px;
		box-shadow: 0 15px 35px rgba(0, 0, 0, 0.25);

		.consultation-badge-icon {
			width: 48px;
			height: 48px;
			border-radius: 14px;
			background: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0 4px 15px rgba(82, 46, 168, 0.3);
		}

		.v-input__slot {
			background: rgba(18, 9, 36, 0.5) !important;
			border: 1px solid rgba(255, 255, 255, 0.12) !important;
			transition: all 0.25s ease;

			&:hover {
				border-color: rgba(142, 92, 255, 0.4) !important;
			}
		}

		.consultant-submit-btn {
			background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%) !important;
			color: #ffffff !important;
			font-weight: 800;
			font-size: 1rem;
			box-shadow: 0 6px 20px rgba(245, 124, 0, 0.35) !important;
			transition: all 0.3s ease !important;

			&:hover {
				transform: translateY(-2px);
				box-shadow: 0 10px 28px rgba(245, 124, 0, 0.5) !important;
			}
		}
	}

	.footer-bottom-bar {
		border-top: 1px solid rgba(255, 255, 255, 0.08);
		padding: 16px 20px;
		width: 100%;
		background: rgba(0, 0, 0, 0.2);
	}
}
</style>
